import { CreatorPermission } from '@api'
import { combine } from 'effector'

import { $currentCreator } from '@/models/creators.ts'

export const $permissions = $currentCreator.map(
  (creator) => creator?.permissions ?? null,
)

export const $hasOnlyFansAdminPermission = $permissions.map(
  (permissions) => !!permissions?.includes(CreatorPermission.OF_ADMIN),
)

export const $hasAccessOnlyfansProfilePermission = $permissions.map(
  (permissions) =>
    !!permissions?.includes(CreatorPermission.ACCESS_ONLYFANS_PROFILE),
)

export const $hasMassMessagesPermission = combine(
  $hasOnlyFansAdminPermission,
  $permissions,
  (isAdmin, permissions) =>
    isAdmin || !!permissions?.includes(CreatorPermission.OF_MASS_MESSAGES),
)

export const $hasReassignPermission = combine(
  $permissions,
  (permissions) => !!permissions?.includes(CreatorPermission.REASSIGN_SALES),
)

export const $hasDeleteMediaPermission = combine(
  $hasOnlyFansAdminPermission,
  $permissions,
  (isAdmin, permissions) =>
    isAdmin ||
    [CreatorPermission.OF_DELETE_MEDIA, CreatorPermission.OF_EDIT_VAULT].every(
      (permission) => (permissions ?? []).includes(permission),
    ),
)

export const $hasBlockingPermission = combine(
  $hasOnlyFansAdminPermission,
  $permissions,
  (isAdmin, permissions) =>
    isAdmin || !!permissions?.includes(CreatorPermission.OF_FAN_BLOCKING),
)

export const $hasHideChatPermission = combine(
  $hasOnlyFansAdminPermission,
  $permissions,
  (isAdmin, permissions) =>
    isAdmin || !!permissions?.includes(CreatorPermission.OF_HIDE_CHATS),
)

export const $hasClearPermission = combine(
  $hasOnlyFansAdminPermission,
  $permissions,
  (isAdmin, permissions) =>
    isAdmin || !!permissions?.includes(CreatorPermission.OF_CLEAR_CHAT),
)

export const $hasModifySettingsPermission = $permissions.map(
  (permissions) => !!permissions?.includes(CreatorPermission.MODIFY_SETTINGS),
)

export const $hasModifySocialAccountsPermission = $permissions.map(
  (permissions) =>
    !!permissions?.includes(CreatorPermission.MODIFY_SOCIAL_ACCOUNTS),
)

export const $hasEditVaultPermission = combine(
  $hasOnlyFansAdminPermission,
  $permissions,
  (isAdmin, permissions) =>
    isAdmin || !!permissions?.includes(CreatorPermission.OF_EDIT_VAULT),
)
